import React, { useCallback } from 'react'
import { PanelHeader } from '../../../../components/PanelHeader/PanelHeader';
import { PanelFooter } from '../../../../components/PanelFooter/PanelFooter';
import { MessageBar, MessageBarType, Panel, PanelType } from '@fluentui/react';
import { IOpenPanel } from '../../../../interfaces/base/IPanel';
import { MessageBarResponse } from "../../../../components/MessageBar/MessageBarResponse";
import { UseUbicacionEliminar } from './UseUbicacionEliminar';
import { ProgressBarLoading } from '../../../../components/ProgressBarLoading/ProgressBarLoading';
import { IUbicacionDTO } from '../../../../interfaces/ubicacion/IUbicacion';


export interface IPanelUbicacionEliminar extends IOpenPanel {
    ubicacionData: IUbicacionDTO
}

const PanelUbicacionEliminar = (props: IPanelUbicacionEliminar) => {

    const { request, deleteUbicacion, loading, reset, mensaje, status } = UseUbicacionEliminar(props)
    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    nameIconHeader="delete"
                    textHeader={`Movilizaciones`}
                    subTextHeader={`Eliminar lugar`}
                />
            </>
        ),
        []
    );

    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Eliminar"
                    onClick={deleteUbicacion}
                    onDismiss={reset}
                />
            </>
        ), [request]
    );

    return (
        <>
            <Panel
                type={PanelType.smallFixedFar}
                onRenderHeader={onRenderHeader}
                onRenderFooter={(!loading && mensaje == "") ? onRenderFooter : undefined}
                isFooterAtBottom
                isOpen={props.isOpen}
                onDismiss={reset}
            >
                <div hidden={mensaje == ""}>
                    <MessageBarResponse
                        objetoResponse={{ codigo: status, mensaje: mensaje }}
                        close={true}
                    />
                </div>
                <div hidden={!loading}>
                    <ProgressBarLoading ></ProgressBarLoading>
                </div>
                <div hidden={loading}>
                    {!mensaje &&
                        <MessageBar
                            delayedRender={false}
                            messageBarType={MessageBarType.severeWarning}
                        >
                            ¿Seguro que quieres eliminar la Ubicación:<strong> {props.ubicacionData?.nombre}</strong>?
                        </MessageBar>
                    }
                </div>
            </Panel>
        </>
    )
}

export { PanelUbicacionEliminar }